module.exports = __webpack_public_path__ + "static/media/2.2e43e12f.jpg";